var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "editLeadDetailsModalRef",
      attrs: {
        id: "edit-lead-details-modal",
        size: "lg",
        title: "Editar detalhes do lead",
        busy: _vm.busyButton
      },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "form",
        {
          ref: "form",
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "2rem",
                width: "100%"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", gap: "2rem", width: "100%" }
                },
                [
                  _c("GenericTextInput", {
                    staticStyle: { width: "25%" },
                    attrs: {
                      label: "*Número da UC",
                      inputId: "uc-number",
                      required: true,
                      validationFunc: _vm.validateTextNotEmpty,
                      state: _vm.validStates.UCNumber,
                      invalidFeedback:
                        "Por favor, insira um número da UC válido."
                    },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.UCNumber = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.UCNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "UCNumber", $$v)
                      },
                      expression: "leadDetailsForm.UCNumber"
                    }
                  }),
                  _vm._v(" "),
                  _c("GenericTextInput", {
                    staticStyle: { width: "75%" },
                    attrs: {
                      label: "*Nome do titular",
                      inputId: "holder-name",
                      required: true,
                      validationFunc: _vm.validateTextNotEmpty,
                      state: _vm.validStates.holderName,
                      invalidFeedback: "Por favor, insira um nome."
                    },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.holderName = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.holderName,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "holderName", $$v)
                      },
                      expression: "leadDetailsForm.holderName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", gap: "2rem", width: "100%" }
                },
                [
                  _c("SCEEPowerSelect", {
                    staticStyle: { width: "25%" },
                    attrs: {
                      label: "Tem energia SCEE?",
                      inputId: "scee-power",
                      required: true,
                      validationFunc: _vm.validateTextNotEmpty,
                      state: _vm.validStates.hasSCEEPower,
                      invalidFeedback: "Por favor, selecione uma opção."
                    },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.hasSCEEPower = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.hasSCEEPower,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "hasSCEEPower", $$v)
                      },
                      expression: "leadDetailsForm.hasSCEEPower"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { width: "25%" },
                      attrs: {
                        label: "Tem conta em atraso?",
                        "label-for": "late-bill"
                      }
                    },
                    [
                      _c("b-form-checkbox", {
                        attrs: {
                          id: "late-bill",
                          checked: Boolean(_vm.leadDetailsForm.hasLateBill),
                          size: "sm"
                        },
                        model: {
                          value: _vm.leadDetailsForm.hasLateBill,
                          callback: function($$v) {
                            _vm.$set(_vm.leadDetailsForm, "hasLateBill", $$v)
                          },
                          expression: "leadDetailsForm.hasLateBill"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("GenericTextInput", {
                    staticStyle: { width: "25%" },
                    attrs: {
                      label: "*Consumo total (kWh)",
                      inputId: "kwh-total-consumption",
                      required: true,
                      validationFunc: _vm.validateTextNotEmpty,
                      state: _vm.validStates.kwhTotalConsumption,
                      invalidFeedback:
                        "Por favor, insira o consumo total em kWh."
                    },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.kwhTotalConsumption = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.kwhTotalConsumption,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.leadDetailsForm,
                          "kwhTotalConsumption",
                          $$v
                        )
                      },
                      expression: "leadDetailsForm.kwhTotalConsumption"
                    }
                  }),
                  _vm._v(" "),
                  _c("GenericTextInput", {
                    staticStyle: { width: "25%" },
                    attrs: {
                      label: "*Número de UC ativas",
                      inputId: "number-of-active-ucs",
                      required: true,
                      validationFunc: _vm.validateTextNotEmpty,
                      state: _vm.validStates.numberOfActiveUCs,
                      invalidFeedback:
                        "Por favor, insira a quantidade de UC ativas."
                    },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.numberOfActiveUCs = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.numberOfActiveUCs,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "numberOfActiveUCs", $$v)
                      },
                      expression: "leadDetailsForm.numberOfActiveUCs"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", gap: "2rem", width: "100%" }
                },
                [
                  _c("PhoneInput", {
                    staticStyle: { width: "25%" },
                    attrs: { state: _vm.validStates.phonePCFA },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.phonePCFA = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.phonePCFA,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "phonePCFA", $$v)
                      },
                      expression: "leadDetailsForm.phonePCFA"
                    }
                  }),
                  _vm._v(" "),
                  _c("EmailInput", {
                    staticStyle: { width: "75%" },
                    attrs: { state: _vm.validStates.emailPCFA },
                    on: {
                      "validation-updated": function($event) {
                        _vm.validStates.emailPCFA = $event
                      }
                    },
                    model: {
                      value: _vm.leadDetailsForm.emailPCFA,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "emailPCFA", $$v)
                      },
                      expression: "leadDetailsForm.emailPCFA"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "Observação", "label-for": "observation" }
                },
                [
                  _c("b-form-textarea", {
                    staticStyle: {
                      "border-radius": "4px",
                      outline: "none",
                      border: "1px solid grey"
                    },
                    attrs: {
                      id: "observation",
                      placeholder: "Observação",
                      debounce: "1000",
                      rows: "3",
                      "max-rows": "6"
                    },
                    model: {
                      value: _vm.leadDetailsForm.observation,
                      callback: function($$v) {
                        _vm.$set(_vm.leadDetailsForm, "observation", $$v)
                      },
                      expression: "leadDetailsForm.observation"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }